export function normalizePermissions(permissions) {
  if (!Array.isArray(permissions)) return [];

  return Array.from(
    new Set(
      permissions
        .filter((permission) => typeof permission === "string")
        .map((permission) => permission.trim().toLowerCase())
        .filter(Boolean),
    ),
  );
}

function normalizePermissionCode(permissionCode) {
  return typeof permissionCode === "string"
    ? permissionCode.trim().toLowerCase()
    : "";
}

export function hasPermission(permissions, permissionCode) {
  const normalizedCode = normalizePermissionCode(permissionCode);
  if (!normalizedCode) return false;

  return normalizePermissions(permissions).includes(normalizedCode);
}

export function hasAnyPermission(permissions, permissionCodes) {
  if (!Array.isArray(permissionCodes) || permissionCodes.length === 0) {
    return false;
  }

  const permissionSet = new Set(normalizePermissions(permissions));

  return permissionCodes.some((permissionCode) =>
    permissionSet.has(normalizePermissionCode(permissionCode)),
  );
}

export function hasAllPermissions(permissions, permissionCodes) {
  if (!Array.isArray(permissionCodes) || permissionCodes.length === 0) {
    return false;
  }

  const permissionSet = new Set(normalizePermissions(permissions));

  return permissionCodes.every((permissionCode) =>
    permissionSet.has(normalizePermissionCode(permissionCode)),
  );
}
